<template>
  <div class="tw-h-full">
    <div class="tw-mb-1">{{ title }}</div>
    <base-list-group listType="ordered" v-if="isLoading">
      <base-list-item>
        <div class="tw-flex tw-justify-between">
          <base-skeleton-loader class="tw-h-4 tw-w-24" />
          <base-skeleton-loader class="tw-h-4 tw-w-4" />
        </div>
      </base-list-item>
      <base-list-item>
        <div class="tw-flex tw-justify-between">
          <base-skeleton-loader class="tw-h-4 tw-w-24" />
          <base-skeleton-loader class="tw-h-4 tw-w-4" />
        </div>
      </base-list-item>
      <base-list-item>
        <div class="tw-flex tw-justify-between">
          <base-skeleton-loader class="tw-h-4 tw-w-24" />
          <base-skeleton-loader class="tw-h-4 tw-w-4" />
        </div>
      </base-list-item>
      <base-list-item>
        <div class="tw-flex tw-justify-between">
          <base-skeleton-loader class="tw-h-4 tw-w-24" />
          <base-skeleton-loader class="tw-h-4 tw-w-4" />
        </div>
      </base-list-item>
      <base-list-item>
        <div class="tw-flex tw-justify-between">
          <base-skeleton-loader class="tw-h-4 tw-w-24" />
          <base-skeleton-loader class="tw-h-4 tw-w-4" />
        </div>
      </base-list-item>
      <base-list-item>
        <div class="tw-flex tw-justify-between">
          <base-skeleton-loader class="tw-h-4 tw-w-24" />
          <base-skeleton-loader class="tw-h-4 tw-w-4" />
        </div>
      </base-list-item>
    </base-list-group>
    <base-list-group v-else-if="sortedAggregates.length > 0" listType="ordered">
      <base-list-item v-for="(s, index) in sortedAggregates" :key="s[idKey]" :showBottomBorder="index != sortedAggregates.length - 1">
        <div class="tw-flex tw-justify-between">
          <div class="tw-text-gray-500 tw-text-xs">{{ s[labelKey] }}</div>
          <div>
            <div v-if="format === 'string'" class="tw-text-xs tw-font-normal">{{ s[valueKey] }}</div>
            <Money-Format v-if="format === 'currency'" :value="s[valueKey]" :locale="locale" :currency-code="s.currency" subunits-value class="tw-text-xs tw-font-normal" />
          </div>
        </div>
      </base-list-item>
    </base-list-group>
    <div v-else class="tw-h-full tw-italic tw-text-center tw-pt-5 tw-text-gray-900 tw-bg-white tw-border tw-border-gray-200 tw-rounded-lg">
      No group results
    </div>
  </div>
</template>

<script>
import MoneyFormat from "vue-money-format";

export default {
  name: "Aggregates",
  components: {
    MoneyFormat,
  },
  props: {
    aggregates: { type: Array, default: null },
    isLoading: { type: Boolean, default: false },
    labelKey: { type: String, default: "label" },
    idKey: { type: String, default: "id" },
    valueKey: { type: [String, Number] },
    title: { type: String, default: "Groups" },
    format: { type: String, default: "string" },
  },
  computed: {
    locale() {
      return window.navigator.language;
    },
    sortedAggregates() {
      return [...this.aggregates].sort((a, b) => b[this.valueKey] - a[this.valueKey]);
    },
  },
};
</script>
